import { render, staticRenderFns } from "./Statistical.vue?vue&type=template&id=01af8484&scoped=true&"
import script from "./Statistical.vue?vue&type=script&lang=js&"
export * from "./Statistical.vue?vue&type=script&lang=js&"
import style0 from "./Statistical.vue?vue&type=style&index=0&id=01af8484&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01af8484",
  null
  
)

export default component.exports